import * as React from 'react';
import { Manager, ManagerProps } from 'react-popper';
import { PlacementManagerContext } from './PlacementManagerContext';

const { useState } = React;

export interface Props extends ManagerProps {}

/**
 * The manager component handles the ref communication between
 * the Placement and PlacementReference components.
 */
const PlacementManager: React.FunctionComponent<Props> = (props: Props) => {
  const [referenceNode, setReferenceNode] = useState<null | HTMLElement>(null);

  return (
    <PlacementManagerContext.Provider value={ { referenceNode, setReferenceNode } }>
      <Manager { ...props } />
    </PlacementManagerContext.Provider>
  );
};

export default PlacementManager;


